import { signOutLink } from '../constants'

export default async function signOut() {
  window.location.assign(signOutLink)
  // Pause here so that the browser never looks frozen (Chrome sometimes takes a few seconds to redirect)
  // Form submission will still show the submit button as submitting and disabled
  await new Promise((resolve) => {
    setTimeout(resolve, 60000)
  })
}
